(ns nl.mediquest.questionnaire-frontend.vitaliteitsscan
  (:require
   [clojure.string :as string]
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n]
   [nl.mediquest.questionnaire-frontend.component.notifications :refer [render-notifications]]
   [nl.mediquest.questionnaire-frontend.util :refer [navigate-to-questionnaire
                                                     get-current-year
                                                     nothing-filled-in?
                                                     labeled-input-field]]
   [nl.mediquest.ui.css :refer [inject-styles! inject-stylesheet!]]
   [reagent.core :as r]))

(defn- legacy-report-url-fix [pathname]
  (cond (= pathname "/") nil
        ;; catch legacy report url and append an arbitrary questionnaire-deployment-id.
        (string/starts-with? pathname "/report/") (str "/q" pathname)
        :else pathname))

(defn set-pathname
  "Vitaliteitsscan uses URL without questionnaire-id, this functions reroutes
  visits to the root URL to the root with questionnaire-id vitaliteitsscan
  appended. Reloads page."
  []
  (let [pathname js/window.location.pathname]
    (set! js/window.location.pathname (str "vitaliteitsscan" (legacy-report-url-fix pathname)))))

;;; DOM manipulation

(def ^:private default-styles
  {:--color-primary "#ff6700"
   :--color-primary-alpha "255, 103, 0"
   :--color-primary-600 "#ff6700"
   :--color-primary-700 "#ff6700"
   :--color-secondary "#456aff"
   :--color-footer "#03003B"})

(defn- set-vitaliteitsscan-title! []
  (set! js/document.title "Scan"))

(defn inject-dom-content! []
  (inject-styles! :css.theme/styles [[":root" default-styles]])
  (inject-stylesheet! :css.theme.custom/href "/custom/vitaliteitsscan/style.css")
  ;; TODO: try to do this via theme config in model.cljs file
  #_(inject-stylesheet! :css.theme.survey/href "/survey-custom-mq.css")
  (set-vitaliteitsscan-title!))

;;; Components

(defn- header []
  [:div.bg-white.w-full
   [:div.container.mx-auto
    [:div.flex.items-center.justify-between.mx-2
     [:a
      {:href "/"}
      [:img {:src "/images/mq-logo.jpg"}]]
     [i18n/language-dropdown]]]
   [:div.border-b.border-gray-300]])

(defn- footer []
  [:div.bg-navy.py-8.text-white
   [:div.container.mx-auto
    [:div.md:flex.justify-between.items-end.mx-4.text-center.md:text-left
     [:div {:class "md:w-1/2"}
      [:a
       {:href "https://home.mediquest.nl"
        :target :_blank}
       [:span.text-xs.text-white "Powered by"]
       [:img.m-auto.md:m-0 {:src "/images/mq-logo-white.svg"
                            :style {:width "100px"}}]]]
     [:div.pt-4.md:pt-0
      [:a.text-white.no-underline
       {:href "/privacy"
        :target :_blank}
       "Privacy Statement"]
      [:div "© " (get-current-year) " Mediquest B.V. All rights reserved."]]]]])

(defn with-header-and-footer [body]
  [:<>
   [render-notifications]
   [:div.flex.justify-between.flex-col.h-full.h-screen
    [:div.flex-grow.bg-white
     [header]
     [:div.container.mx-auto
      [:div.mx-4
       [body]]]]
    [footer]]])

(defn vragenlijstcode-form []
  (let [state (r/atom {:questionnaire-deployment-id nil})]
    (fn []
      [:form.bg-white
       {:on-submit
        (fn [e]
          (.preventDefault e)
          (navigate-to-questionnaire @state))}
       [:div.md:flex.items-center
        [:div.pb-3.md:pb-0
         [labeled-input-field state :questionnaire-deployment-id (i18n/text :landing-page/organization-code) true]]
        [:div.md:pl-3
         [:span.button.text-white.bg-primary
          {:on-click #(navigate-to-questionnaire @state)
           :disabled (nothing-filled-in? state)}
          [i18n/text :landing-page/retrieve]]]]])))

(defn landing-page []
  [:div.m-4
   [:p.text-xl [i18n/text :landing-page/title]]
   [:p [i18n/text :landing-page/introduction]]
   [:p.mt-4.mb-4 [i18n/text :landing-page/fill-in-code]]
   [vragenlijstcode-form]
   [:p.mt-4.title.text-xl [i18n/text :landing-page/anonymous]]
   [:p [i18n/text :landing-page/mediquest]
    [:a {:href "/privacy" :target :_blank} [i18n/text :landing-page/here]]
    " " [i18n/text :landing-page/full-statement]]
   [:p.mt-8.text-xl [i18n/text :landing-page/questions]]
   [:p [i18n/text :landing-page/contact-vitaliteitsscan]
    [:a.underline {:href "mailto:vitaliteitsscan@mediquest.nl"
                   :target :_blank}
     "vitaliteitsscan@mediquest.nl"]
    "."]])
